import { render, staticRenderFns } from "./BanksSugestions.vue?vue&type=template&id=8483b480&scoped=true&"
import script from "./BanksSugestions.vue?vue&type=script&lang=js&"
export * from "./BanksSugestions.vue?vue&type=script&lang=js&"
import style0 from "./BanksSugestions.vue?vue&type=style&index=0&id=8483b480&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8483b480",
  null
  
)

export default component.exports